import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { General } from './General'
import { Basic } from './Basic'
import { Info } from './Info'

export const EmployerProfileDetails = () => {
  const { t } = useTranslation()

  return (
    <>
      <General />

      <Basic />

      <Info />
    </>
  )
}

EmployerProfileDetails.propTypes = {}
